package com.gastoncantera.intercom.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import kotlinx.browser.document
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.await
import kotlinx.coroutines.launch
import org.w3c.dom.events.Event
import kotlin.js.Promise

/**
 * Screen Wake Lock API (Chrome/Edge/Safari recientes). Si el browser no lo soporta o falla,
 * no hace nada: la pestaña sigue atenuándose según el SO.
 */
@Composable
actual fun KeepScreenOn(active: Boolean) {
    DisposableEffect(active) {
        if (!active) return@DisposableEffect onDispose { }

        val scope = CoroutineScope(SupervisorJob() + Dispatchers.Default)
        var lock: dynamic = null
        var requestJob: Job? = null

        fun request() {
            requestJob?.cancel()
            requestJob = scope.launch {
                try {
                    val wakeLock = document.asDynamic().wakeLock ?: return@launch
                    lock = (wakeLock.request("screen") as Promise<dynamic>).await()
                } catch (_: Throwable) {
                    // API ausente, permiso denegado o documento no visible.
                }
            }
        }

        fun release() {
            requestJob?.cancel()
            requestJob = null
            try {
                lock?.release()
            } catch (_: Throwable) {
            }
            lock = null
        }

        // Al volver a la pestaña el wake lock se libera solo: hay que pedir de nuevo.
        val onVisibility: (Event) -> Unit = {
            if (document.asDynamic().visibilityState == "visible" && lock == null) request()
        }

        request()
        document.addEventListener("visibilitychange", onVisibility)

        onDispose {
            document.removeEventListener("visibilitychange", onVisibility)
            release()
        }
    }
}
